import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { DialogSummaryPaymentModel } from '@app/shared/models/dialog-summary-payment.model';
import { ElementsTableSummaryPayment } from '@app/shared/models/elements-table-sumamry-payment.model';
import { GetDetailODCStringCommand } from '@app/modules/management/command/get-detail-odc-string.command';
import { OrdersService } from '@app/modules/management/services/orders.service';
import { ResponseStatus } from '@app/core/enums/response-status.enum';
import { HttpServerResponse } from '@app/core/models/response.model';
import { LoggerService } from '@app/core/services/logger.service';
import { AuthenticationService } from '@app/modules/authentication/services/authentication.service';
const logger = new LoggerService('ModalPaymentSummaryComponent');

 const ELEMENT_DATA: ElementsTableSummaryPayment[] = [];

@Component({
  selector: 'dhl-modal-payment-summary',
  templateUrl: './modal-payment-summary.component.html',
  styleUrls: ['./modal-payment-summary.component.scss']
})
export class ModalPaymentSummaryComponent implements OnInit {
  ELEMENT_DATA: ElementsTableSummaryPayment[] = [];
  displayedColumns: string[] = ['date', 'pay', 'amount', 'amountPaid', 'balance'];
  dataSource = new MatTableDataSource<ElementsTableSummaryPayment>(this.ELEMENT_DATA);
  selection = new SelectionModel<ElementsTableSummaryPayment>(true, []);
  dialogData: DialogSummaryPaymentModel;
  srcData: ElementsTableSummaryPayment[] = this.ELEMENT_DATA;

  disableButtonTerms: boolean = true;

  @ViewChild('scroll') scroll!: ElementRef;

  orderId: string = '';

  ngOnInit(): void {
    const command: GetDetailODCStringCommand = {
      orderId: this.dialogData.OrderId
    };
    this.callServiceDetailOdc(command);
  }

  constructor(public dialogRef: MatDialogRef<GenericDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogSummaryPaymentModel,
    private readonly authenticationService: AuthenticationService,
    public odcService: OrdersService) {
    this.dialogData = data;
  }

  // Servicio que trae los detalles de odc tesoreria
  callServiceDetailOdc(command: GetDetailODCStringCommand) {
    this.odcService.getPDetailODCResumen(command).subscribe({
      next: (response: HttpServerResponse<any>) => {
        if (response.status === ResponseStatus.Ok) {
          logger.info('ok');
          for (const element of response.data.paymentSummary) {
            this.ELEMENT_DATA.push({pay: element.pay, date: element.date, totalToPay: element.totalToPay, amount: element.amount, amountPaid: element.amountPaid, balance: element.balance, orderId: element.orderId});
          }
          this.dataSource = new MatTableDataSource<ElementsTableSummaryPayment>(this.ELEMENT_DATA);
          this.orderId = this.ELEMENT_DATA[0].orderId;
        }
      },
      error: (e) => {
        logger.error(e);
        this.authenticationService.validateLogued(e);
      },
      complete: () => {
        // This is intentional
      }
    });
  }

  /**
   * On Accept dialog generic action
   */
  onAccept(): void {
    this.dialogRef.close(true);
  }

  /**
   * On Cancel dialog generic action
   */
  onCancel(): void {
    this.dialogRef.close(false);
  }
}
